import React from "react";
import ManagerNavbar from "../Layout/ManagerNavbar";
import MyInterviewsPage from "../placement/MyInterviewsPage";

export default function ManagerMyInterviewsPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <ManagerNavbar />
      <MyInterviewsPage />
    </div>
  );
}
